import mapboxgl from "mapbox-gl";

export default function createGeoLocate() {
  const map = window.map;
  const geolocate = new mapboxgl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true,
    },
    trackUserLocation: true,
    showUserLocation: true,
    showAccuracyCircle: true,
  });

  // Handle successful geolocation
  geolocate.on("geolocate", (event) => {
    window.geolocateLocated();
  });

  // Handle geolocation errors
  geolocate.on("error", (error) => {
    console.error("Error getting location:", error);
    window.geolocateError();
    // alert("Error getting location: " + error.message);
  });

  // Custom method to check permissions and trigger geolocation
  geolocate.permissionAndTrigger = () => {
    if ("geolocation" in navigator) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((result) => {
          if (result.state === "granted") {
            geolocate.trigger();
          } else if (result.state === "prompt") {
            navigator.geolocation.getCurrentPosition(
              () => {
                geolocate.trigger();
              },
              () => {
                console.error("User denied permission to access location");
                alert("User denied permission to access location");
                window.geolocateError();
              }
            );
          } else {
            console.error("User denied permission to access location");
            alert("Please enable location services to use this feature");
            window.geolocateError();
          }
        })
        .catch((error) => {
          console.error("Permission query failed:", error);
          window.geolocateError();
          alert("Failed to check location permissions: " + error.message);
        });
    } else {
      alert("Geolocation is not available on your device. Please contact support@hiiker.co");
      console.error("Geolocation is not available");
      window.geolocateError();
    }
  };

  // Add the control to the map
  map.addControl(geolocate);

  // Hide the default button after the map loads
  const hideGeolocateButton = () => {
    const element = document.querySelector(".mapboxgl-ctrl-geolocate");
    if (element) {
      element.style.display = "none";
    } else {
      console.warn("Element not found in the DOM.");
    }
  };

  let mapRenderInstance = null;

  const mapRendered = () => {
    console.log("Map rendered");
    if (map.loaded()) {
      console.log("Map loaded, hiding button now");
      hideGeolocateButton();
      map.off("render", mapRenderInstance);
    }
  }

// Run if already loaded, or wait for load if not
  if (map.loaded()) {
    console.log("Map already loaded, hiding button now");
    hideGeolocateButton();
  } else {
    console.log("Map not loaded, waiting for events");
    map.on("load", () => {
      console.log("Map 'load' event fired");
      hideGeolocateButton();
    });
    mapRenderInstance = mapRendered;
    map.on("render", mapRenderInstance);
  }

  // Expose the geolocate control globally
  window.geoLocate = geolocate;
}
